module.exports = __webpack_public_path__ + "img/arrow-down-from-line.71e42baf.svg";